export const getOfferAppliedAmount = () => sessionStorage.getItem('offerNudgeAmount');
export const setOfferAppliedAmount = (amount: number) => sessionStorage.setItem('offerNudgeAmount', amount.toString());
export const removeOfferAppliedAmount = () => sessionStorage.removeItem('offerNudgeAmount');